<template>
  <v-row justify="center">
    <v-dialog v-model="dialog2" persistent max-width="950px">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header Principal estilo Inspección -->
        <v-toolbar height="58" color="secondary" dark flat class="px-2 px-sm-4 table-header-toolbar">
          <div class="header-main-info d-flex align-center min-width-0">
            <div class="header-icon-box mr-2 mr-sm-3">
              <v-icon>mdi-account-multiple-plus</v-icon>
            </div>
            <div class="header-titles min-width-0">
              <span class="header-company-title font-weight-bold text-truncate d-block">
                Contactos de {{ ItemsCliente.razon_social }}
              </span>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="cerrarDialogo()" class="btn-circle-tooltip ml-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-form enctype="multipart/form-data" ref="form" lazy-validation>
          <v-card-text class="pa-3 pa-sm-4 pa-md-5 pb-2">
            <!-- SECCIÓN: DATOS DEL CONTACTO -->
            <div class="section-title d-flex align-center mb-3">
              <v-icon color="secondary" small class="mr-2">mdi-card-account-details</v-icon>
              <span class="text-subtitle-2 font-weight-bold text--primary">
                {{ ItemContacto.id == 0 ? "Registrar Nuevo Contacto" : "Editar Contacto" }}
              </span>
            </div>

            <v-row dense class="mb-2">
              <v-col cols="12" sm="6" md="6" class="pa-2">
                <v-text-field
                  label="Nombre Completo *"
                  placeholder="Ej. Juan Pérez"
                  hide-details="auto"
                  v-model="ItemContacto.nombre"
                  outlined
                  dense
                  prepend-inner-icon="mdi-account"
                  class="rounded-lg"
                  :rules="requeridos"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="pa-2">
                <v-text-field
                  label="Correo Electrónico *"
                  placeholder="ejemplo@correo.com"
                  hide-details="auto"
                  v-model="ItemContacto.correo"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email-outline"
                  class="rounded-lg"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="pa-2">
                <v-text-field
                  label="Teléfono / Celular *"
                  placeholder="Ej. 987654321"
                  hide-details="auto"
                  v-model="ItemContacto.telefono"
                  type="number"
                  outlined
                  dense
                  prepend-inner-icon="mdi-phone-outline"
                  class="rounded-lg"
                  :rules="requeridos"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" class="pa-2">
                <v-autocomplete
                  v-model="ItemContacto.cargo"
                  :items="ItemsCargo"
                  dense
                  outlined
                  hide-details="auto"
                  prepend-inner-icon="mdi-briefcase-outline"
                  label="Seleccionar Cargo *"
                  :rules="requeridos"
                  class="rounded-lg"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" class="pa-2">
                <v-checkbox
                  v-model="ItemContacto.reporte"
                  label="Incluir contacto en el Reporte Consolidado"
                  color="primary"
                  dense
                  hide-details
                  class="mt-1"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="form-card-actions pa-3 pa-sm-4 bg-light border-top">
            <v-spacer class="d-none d-sm-flex"></v-spacer>
            <v-btn
              outlined
              color="grey darken-1"
              class="btn-form-action text-capitalize px-4 rounded-lg mr-sm-2 font-weight-medium"
              @click="cancelar()"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Limpiar
            </v-btn>
            <v-btn
              v-if="ItemContacto.id == 0"
              color="primary"
              elevation="1"
              class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
              @click="agregar()"
            >
              <v-icon left small>mdi-plus-circle</v-icon>
              Agregar Contacto
            </v-btn>
            <v-btn
              v-else
              color="primary"
              elevation="1"
              class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
              @click="agregar()"
            >
              <v-icon left small>mdi-pencil</v-icon>
              Actualizar Contacto
            </v-btn>
          </v-card-actions>
        </v-form>

        <div class="pa-3 pa-sm-4 pt-2">
          <Tabla
            Titulo="Lista de Contactos Registrados"
            :Cabecera="Cabecera"
            :Items="ItemsContacto"
            :Excel="false"
            :Buscar="false"
          />
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Tabla from "@/components/tabla.vue"
export default {
    props:['dialog2','ItemsCliente','Titulo'],
    components:{
        Tabla
    },
    methods:{
        ...mapActions('cliente',['agregarContacto','cargarContacto']),        
        async agregar(){
            if(this.$refs.form.validate()){
                this.$alertify.confirm(
                    this.ItemContacto.id  == 0 ? "Desea Agregar Item" : "Desea Editar Item", 
                    () => {
                            this.ItemContacto.id_cliente = this.ItemsCliente.id
                            this.agregarContacto(this.ItemContacto)
                            .then( r =>{
                                this.LimpiarCampos();
                                this.$alertify.success(this.ItemContacto.id  == 0 ? "Agregado" : "Actualizado");
                                this.$refs.form.reset();
                            });
                        }, 
                    () => {
                            this.verContacto(this.ItemsCliente)
                            this.$alertify.error("Se cancelo la acción")
                        } 
                ).setHeader('<em> Aviso </em> ');
            }
        },
        LimpiarCampos(){
            this.ItemContacto.id = 0;
            this.ItemContacto.reporte = false;
        },
        cerrarDialogo(){
            this.$emit('dialog2',false);
        },
        cancelar(){
            this.$refs.form.reset();
            LimpiarCampos();
        },
    },
    computed:{
        ...mapGetters('cliente',['ItemsContacto','ItemContacto','ItemsCargo'])  
    },
    data() {
        return {
            imagenminiatura: '/images/reporte/imagen_no_disponible.jpg',
            emailRules: [
                v => !!v || 'E-mail es requerido',
                v => /.+@.+\..+/.test(v) || 'E-mail no es valido',
            ],
            requeridos: [
                v => !!v || 'Este Campo es Requerido.'
            ],
            Cabecera:[
                {text:'Acción',value:'accion'},
                {text:'Id',value:'id'},
                {text:'Nombre',value:'nombre'},
                {text:'Correo',value:'correo'},
                {text:'Teléfono',value:'telefono'},
                {text:'Cargo',value:'cargo'},
                {text:'Incluido en Reporte',value:'reporte'},
            ],
        };
    },
}
</script>

<style scoped>
.min-width-0 {
  min-width: 0 !important;
}

.table-header-toolbar {
  min-height: 58px;
}

.header-main-info {
  flex: 1 1 auto;
}

.header-icon-box {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-company-title {
  font-size: 1.05rem;
  letter-spacing: 0.2px;
  line-height: 1.25;
}

.section-title {
  border-left: 3px solid var(--v-secondary-base, #424242);
  padding-left: 8px;
}

.bg-light {
  background-color: #f8fafc !important;
}

.border-top {
  border-top: 1px solid #e2e8f0 !important;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px !important;
    height: auto !important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }

  .header-icon-box {
    width: 30px;
    height: 30px;
    min-width: 30px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.88rem !important;
  }

  .form-card-actions {
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    gap: 8px !important;
  }

  .btn-form-action {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>

